<template>
  <b-navbar
    class="text-left"
    toggleable="md"
  >
    <div class="container">
      <router-link :to="{ path: '/'}">
        <img
          v-if="appName === 'Planetajob'"
          class="logo-dark"
          src="@/assets/planetajob_logo_dark.png"
        >
        <img
          v-if="appName === 'Aicad Jobs'"
          style="height: 60px;"
          src="@/assets/aicad_logo_dark.png"
        >
      </router-link>
      <b-navbar-toggle target="nav-collapse" />
      <b-collapse
        id="nav-collapse"
        class="mt-4"
        is-nav
      >
        <div class="portalHeadline --black">
          {{ isLocalEnv ? 'LOCAL DEVELOPMENT' : '' }}
        </div>
        <LanguagePicker :dark="false" />
        <div
          class="navigation"
          style="white-space: nowrap;"
        >
          <div
            v-if="!$auth.check()"
            style="width: 250px;"
            class="text-right"
          >
            <b-button
              variant="info"
              class="search-button search-button--inverted mr-2"
              style="text-transform: uppercase;"
              @click="navigate('company-home')"
            >
              {{ $t('main.navbar.login-as-company', 'Business access') }}
            </b-button>
            <b-button
              variant="info"
              class="search-button"
              style="text-transform: uppercase;"
              @click="navigate('Login')"
            >
              {{ $t('main.navbar.login-as-candidate', 'Candidate access') }}
            </b-button>
          </div>
          <div
            v-else
            class="text-right"
          >
            <span
              class="mr-2 menu-item"
              style="cursor: pointer;"
              @click="$router.push({name: 'my-account', query: { profile: true }})"
            >
              {{ $auth.user().first_name }}
            </span>
            <b-button
              variant="info"
              class="search-button menu-item"
              style="text-transform: uppercase;"
              @click="$router.push({ name: 'dashboard' })"
            >
              {{ $t('generic.dashboard', 'Dashboard') }}
            </b-button>
            <a
              id="logout"
              class="ml-2 menu-item"
              @click="logout"
            >
              {{ $t('generic.sign-off', 'Sign off') }}
            </a>
          </div>
        </div>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
import LanguagePicker from "@/components/LanguagePicker";
export default {
    components: {LanguagePicker},
    computed: {
    isLocalEnv() {
      return process.env.NODE_ENV === 'development';
    },
    appName() {
      return process.env.VUE_APP_NAME;
    }
  },
  methods: {
    logout() {
      this.$auth.logout({
        makeRequest: true,
        params: {}, // data: {} in axios
        success: function () {},
        error: function () {},
        redirect: '/login',
      });
    },
    setLoginContext(loginContext) {
      window.localStorage.setItem('login-context', loginContext);
    },
    navigate(routeName) {
      switch (routeName) {
        case 'Login':
          this.setLoginContext('candidate');
          break;
        case 'company-home':
          this.setLoginContext('company');
          break;
      }

      this.$router.push({ name: routeName });
    },
  }
}
</script>

<style lang="scss" scoped>
  .header {
    padding: 15px 25px;
    display: flex;
    width: 65%;
    margin: auto;
    justify-content: space-between;
  }

 .search-button {
    background: #658bc7;
    border: 1px solid #658bc7;
    border-radius: 15px;
    font-weight: 600;
    font-size: 0.8rem;
    padding: 5px 10px;
    transition: 0.3s ease;

    &:hover {
      background: #006060;
      border: 1px solid #006060;
      transition: 0.3s ease;
    }

    &--inverted {
      background: #fff;
      color: #658bc7;
      border: 1px solid #658bc7;
      transition: 0.3s ease;
    }
 }

 .menu {
   a {
    text-decoration: none;

     &:hover {
       color: #009090 !important;
     }
   }
 }

  @media screen and (max-width: 991px) {
    .navbar {
      background: #eee;
      text-align: center !important;

      .search-button {
        margin: 5px;
        width: 100%;
        max-width: 200px;
        display: block;
      }

      .menu a {
        font-weight: 600;
      }
    }
  }

  @media screen and (max-width: 767px) {
    .menu-item {
      width: 100%;
    }
    .navbar {
      .search-button {
        margin: 5px;
        width: 100%;
        max-width: unset;
        display: block;
      }
    }
  }
</style>
